export const massUploadOptions = [
  { name: 'Monthly Mileage', serviceName: 'MonthlyMileage'},
  { name: 'Tire Change', serviceName: 'TireChange'},
  { name: 'Mass Details', serviceName: 'MassDetails'},
  { name: 'Registered Vehicles', serviceName: 'RegisteredVehicles'},
  { name: 'RV With Torque And PSI', serviceName: 'RVWithTorqueAndPSI'},
];